import React from 'react';
import style from './ProgressBar.style';
import { DISHOP_GREEN } from '../../constants';
import { useAppSelector } from '../../redux/hook';

export default function ProgressBar({ progress, isComplete = false }) {
  const { secondaryColor } = useAppSelector(
    (state) => state.configurationReducer
  );
  const value = `${isComplete ? 100 : Math.round(progress * 100)}%`;
  return (
    <div style={style.progressBarContainer}>
      <div
        style={{
          ...style.progressBar,
          width: value,
          backgroundColor: isComplete
            ? DISHOP_GREEN
            : secondaryColor ?? '#E6BD25',
        }}
      >
        <span style={style.progressText}>{value}</span>
      </div>
    </div>
  );
}
